import api from './index'

class WheelService {
    fetchSetting() {
        return api.get('/wheel')
    }
    updateSetting(data) {
        return api.post('/wheel', data)
    }
}

export default new WheelService()